import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import {
    fetchBiometricDeviceTransactionsPage,
    selectBiometricTransactions,
} from '../features/biometric-transaction/biometric-transaction.slice';
import { getDefaultBiometricTransactionSearchCriteria } from '../service/model/biometric.model';

const useBiometricTransactions = (deviceId?: number) => {
    const dispatch = useAppDispatch();
    const biometricTransactions = useAppSelector(selectBiometricTransactions);

    const getBiometricTransactions = async () => {
        const search = getDefaultBiometricTransactionSearchCriteria();
        search.deviceId = deviceId;

        await dispatch(fetchBiometricDeviceTransactionsPage(search));
    };

    useEffect(() => {
        if (deviceId && biometricTransactions.length === 0) {
            getBiometricTransactions();
        }
    }, [biometricTransactions.length, deviceId]);

    return [biometricTransactions, getBiometricTransactions] as const;
};

export default useBiometricTransactions;
